import { keyframes } from 'styled-components';

/**
 * Animação de fade in com movimento vertical
 * Usada em cards, modais e elementos que aparecem na tela
 */
export const fadeIn = keyframes`
    from {
        opacity: 0;
        transform: translateY(20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
`;

/**
 * Animação de fade in simples sem movimento
 */
export const fadeInSimple = keyframes`
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
`;

/**
 * Animação de slide in da esquerda
 */
export const slideInLeft = keyframes`
    from {
        opacity: 0;
        transform: translateX(-20px);
    }
    to {
        opacity: 1;
        transform: translateX(0);
    }
`;

/**
 * Animação de rotação (loading spinners)
 */
export const spin = keyframes`
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
`;
